import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

import { EditChallengesPostType } from 'features/challenge/config/types';
import { useUserId } from 'features/user/hooks/useUserId';

type TUseEditChallengesMutation<TChallengeType> = {
  options?: UseMutationOptions<
    { challenges: TChallengeType[] },
    Error,
    EditChallengesPostType<TChallengeType>,
    { challenges: TChallengeType[] }
  >;
};

export const useEditChallengesMutation = <TChallengeType>({
  options,
}: TUseEditChallengesMutation<TChallengeType>) => {
  const { request } = useMutationHTTPRequest();
  const userId = useUserId();

  return useMutation(
    async ({
      challenges,
      parameters,
    }: EditChallengesPostType<TChallengeType>) =>
      await request({
        url: `/api/challenges/edit`,
        body: {
          targetUserId: userId,
          challenges: Array.isArray(challenges) ? challenges : [challenges],
          parameters,
        },
      }),
    options
  );
};
